var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"d-flex py-5 mb-2 align-start",attrs:{"color":_vm.color,"outlined":"","label":""}},[_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.$props.label)+" : ")]),_c('div',{staticClass:"text-body-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm._f("toINR")(_vm.modelValue))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }